export { default } from './PIMAssetsCarousel';
